import { render } from "./DonateButton.vue?vue&type=template&id=2b1a81b7&scoped=true"
import script from "./DonateButton.vue?vue&type=script&lang=js"
export * from "./DonateButton.vue?vue&type=script&lang=js"

import "./DonateButton.vue?vue&type=style&index=0&id=2b1a81b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1a81b7"]])

export default __exports__